export const shortenTableEntry = (entry, numberOfCharacters) =>
  entry && (entry.length > numberOfCharacters)
    ? `${entry.substr(0, numberOfCharacters)}...`
    : entry;

export const formatAddressMiddle = (address) =>
  address.length > 18
    ? `${address.substr(0, 6)}...${address.substr(
      address.length - 6,
      address.length
    )}`
    : address;

export const prepareStringForDisplay = (str) => {
  try {
    str = decodeURIComponent(str?.replace(/\+/g, " "));
    return str;
  } catch (e) {
    // if error caught then string is not to be decoded and just return it
    return str;
  }
};

export const getDateTime = (date) => {
  const formattedDate = new Date(date);
  if (date !== null)
    return `${formattedDate.toLocaleDateString()} ${formattedDate.toLocaleTimeString()}`;
  else return date;
};

export const getShortDateTime = (theDate) => {
  const formattedDate = new Date(theDate);
  let date = formattedDate.toLocaleDateString();
  let time = formattedDate.toLocaleTimeString();
  return { date, time };
};

const subst = [
  { long: "Wydawnictwo", short: "wyd." },
  { long: "Biblioteka Publiczna Gminy", short: "BP Gm." },
  { long: "Biblioteka Publiczna", short: "BP" },
  { long: "Biblioteka Publiczna w Dzielnicy ", short: "BP w dz." },
  { long: "Gminna Biblioteka Publiczna", short: "Gm. BP" },
  { long: "Gminnej Biblioteki Publicznej", short: "Gm. BP" },
  { long: "Miejska Biblioteka Publiczna", short: "M. BP" },
  { long: "Miejsko-Gminna Biblioteka Publiczna", short: "M-Gm. BP" },
  { long: "Powiatowa Biblioteka Publiczna", short: "Pow. BP" },
  { long: "Samorządowa Biblioteka Publiczna", short: "Samorz. BP" },
]

export const getShortAddresName = (address) => {
  // if starts wiuth "Wydawnictwo" shorten to "Wyd."
  let subsituted = false;
  for (const { long, short } of subst) {
    if (address.startsWith(long)) {
      address = address.replace(long, short);
      subsituted = true;
      break;
    }
  }
  if (!subsituted && address.length > 24) {
    address = address.slice(0, 24) + "...";
  }
  return address;

};

export function parseAuthorName(fullName) {
  if (!fullName) return { surname: '', givenNames: '', titles: '' };

  const name = fullName.trim();
  const parts = name.split(/\s+/); // Split by any whitespace

  if (parts.length < 2) return { surname: name, givenNames: '', titles: '' };

  // Titles and honorifics (case-insensitive)
  const titlePatterns = [
    'dr', 'dr.', 'prof', 'prof.', 'mgr', 'mgr.', 'inż', 'inż.', 'lek', 'lek.',
    'hab', 'hab.', 'habil', 'habil.',
    'ks', 'ks.', 'bp', 'bp.', 'abp', 'abp.', 'kard', 'kard.',
    'gen', 'gen.', 'płk', 'płk.', 'mjr', 'mjr.', 'kpt', 'kpt.', 'por', 'por.',
    'sir', 'lord', 'lady', 'count', 'baron', 'duke', 'duchess',
    'jr', 'jr.', 'sr', 'sr.', 'ii', 'iii', 'iv', 'v'
  ];

  // Particles that belong to surname
  const particles = [
    'le', 'la', 'les', 'de', 'du', 'des', 'da', 'das', 'do', 'dos',
    'von', 'van', 'der', 'den', 'ter', 'ten', 'op', 'aan',
    'al', 'bin', 'ibn', 'abu',
    'mc', 'mac', "o'", 'fitz',
    'di', 'del', 'della', 'dello', 'degli', 'delle'
  ];

  const titles = [];
  const namePartsWithoutTitles = [];

  // Extract titles from the beginning and end
  for (const part of parts) {
    const lowerPart = part.toLowerCase().replace(/['']/g, '');
    if (titlePatterns.includes(lowerPart)) {
      titles.push(part);
    } else {
      namePartsWithoutTitles.push(part);
    }
  }

  if (namePartsWithoutTitles.length < 2) {
    return {
      surname: namePartsWithoutTitles[0] || '',
      givenNames: '',
      titles: titles.join(' ')
    };
  }

  // Find surname start (including particles)
  let surnameStartIndex = namePartsWithoutTitles.length - 1;

  // Work backwards to find particles
  for (let i = namePartsWithoutTitles.length - 2; i >= 0; i--) {
    const part = namePartsWithoutTitles[i].toLowerCase().replace(/['']/g, '');
    if (particles.includes(part)) {
      surnameStartIndex = i;
    } else {
      break;
    }
  }

  const givenNames = namePartsWithoutTitles.slice(0, surnameStartIndex).join(' ');
  const surname = namePartsWithoutTitles.slice(surnameStartIndex).join(' ');

  return {
    surname: surname,
    givenNames: givenNames,
    titles: titles.join(' ')
  };
}

export function formatAuthorForMARC21(fullName) {
  const { surname, givenNames, titles } = parseAuthorName(fullName);

  if (!surname) return fullName;

  const formattedGivenNames = [titles, givenNames].filter(Boolean).join(' ');

  return formattedGivenNames ? `${surname}, ${formattedGivenNames}` : surname;
}
